!function () {
    angular.module('DSSXAPP').component('searchCategory', {
        template:'<section class="search-category-view" ng-mouseenter="vm.isHover = true" ng-mouseleave="vm.isHover = false"><div class="sc-trigger"><i class="iconfont icon-category"></i> {{ vm.txt.categories ? vm.txt.categories : \'Categories\'}} <i class="iconfont" ng-class="{\'icon-moreunfold\': !vm.isHover, \'icon-less\': vm.isHover}"></i></div><div class="sc-content"><ul><li ng-repeat="cs in vm.categories track by $index"><div class="sc-title"><span ng-repeat="c in cs track by $index"><a ng-href="{{vm.mainCatePage}}{{vm.encode(c.data.catId)}}&cate={{vm.encode(c.enName)}}">{{c.enName}}</a><span ng-show="!$last">&nbsp;/&nbsp;</span></span> <i class="iconfont icon-more"></i></div><div class="sc-detail"><div ng-repeat="c in cs track by $index"><a ng-href="{{vm.mainCatePage}}{{vm.encode(c.data.catId)}}&cate={{vm.encode(c.enName)}}">{{c.data.enName}}</a><ul><li ng-repeat="i in c.data.child track by $index" ng-hide="$index > 5"><a ng-href="{{vm.searchPage}}{{vm.encode(c.data.enName + \'@\' + i.enName)}}&mainCatId={{c.data.catId}}">{{i.enName}}</a></li><li><a ng-href="{{vm.mainCatePage}}{{vm.encode(c.data.catId)}}&cate={{vm.encode(c.enName)}}">View More</a></li></ul></div></div></li><li><a>All Categories</a></li></ul></div></section>',
        controllerAs: 'vm',
        bindings: {
            txt: '<',
        },
        controller: ['request', function (request) {
            this.$onInit = onInit;

            var vm = this;
            var util = DSSX.util;
            vm.isHover = false;
            vm.categories = [];
            vm.searchPage = '/search.html?category=';
            vm.mainCatePage = '/cate-detail.html?catId=';

            vm.encode = function (arg_data) {
                return encodeURIComponent(arg_data);
            };

            function convertCategories(arg_data) {
                var temp = [];
                var level1 = util.safe(arg_data, 'home_expand_cate', []),
                    level1Data = util.safe(arg_data, 'parentId_parentCate_map', {}),
                    level2 = util.safe(arg_data, 'parentId_subCates_map', {});

                angular.forEach(level1Data, function (v, k) {
                    this.push(angular.extend(v, {child: util.safe(level2, k, [])}));
                }, temp);

                angular.forEach(level1, function (v, k) {
                    angular.isArray(v) && angular.forEach(v, function (e, i) {
                        level1[k][i].data = angular.copy(level1Data[e.catId]);
                    });
                });

                return level1;
            }

            function onInit() {

                request.get('/pub/api/productCat?level=2', {}, false)
                    .then(function (rs) {
                        vm.categories = convertCategories(util.safe(rs, 'data', {}));
                    }, function (error) {
                        DSSX.dialog.err(error, {
                            moduleName: 'search-category.js',
                            funcName: 'onInit',
                            text: '获取分类信息失败'
                        });
                    });
            }
        }]
    })
}();
